import { useSitecoreContext } from './useSitecoreContext';

export function useGlobalLinks() {
	const { sitecoreContext } = useSitecoreContext();
	return sitecoreContext?.globalLinks || {};
}
